import LegalPage from './LegalPage';

function Section({ title, children }) {
  return (
    <div>
      <h2 className="text-lg font-medium text-[#00163E] mb-3">{title}</h2>
      {children}
    </div>
  );
}

function P({ children }) {
  return <p className="mb-3">{children}</p>;
}

function List({ items }) {
  return (
    <ul className="list-disc list-inside space-y-1.5 mb-3 ml-2">
      {items.map((item, i) => <li key={i}>{item}</li>)}
    </ul>
  );
}

export default function TerminosPage() {
  return (
    <LegalPage title="Términos de Uso" pageTitle="Conadvy | Términos de Uso">
      <p className="text-[#8A9BB1] text-xs mb-8">Última actualización: [FECHA]</p>

      <Section title="1. Identificación y aceptación">
        <P>Los presentes Términos de Uso regulan la solicitud y, en su caso, la prestación de los servicios ofrecidos por <strong>[RAZÓN SOCIAL, S.L.]</strong> (NIF [NIF/CIF], domicilio en [DOMICILIO]; en adelante, "Conadvy") a través del sitio web conadvy.com.</P>
        <P>El envío de cualquier formulario del sitio web implica la aceptación de estos Términos y de la <a href="/privacidad" className="text-[#C58C40] hover:underline">Política de Privacidad</a>. Los servicios de Conadvy están dirigidos exclusivamente a empresas y profesionales en el ejercicio de su actividad; no se dirigen a consumidores.</P>
      </Section>

      <Section title="2. Descripción del servicio">
        <P>Conadvy es un servicio de intermediación cualificada que conecta empresas con profesionales senior independientes ("Advisors") mediante un proceso confidencial que comprende:</P>
        <List items={[
          'Diagnóstico — análisis de la necesidad estratégica de la empresa.',
          'Selección — identificación de un máximo de tres perfiles con mayor encaje, presentados inicialmente de forma anonimizada.',
          'Confidencialidad — suscripción de NDA como condición previa a la revelación de identidades.',
          'Conexión — puesta en contacto para la formalización de la colaboración.',
        ]} />
        <P>Conadvy presta un servicio de diagnóstico, selección y conexión. <strong>Conadvy no es parte de la relación profesional que la empresa y el Advisor establezcan entre sí</strong>, ni presta por sí misma servicios de consultoría o asesoramiento estratégico.</P>
      </Section>

      <Section title="3. Solicitud de acceso y verificación">
        <P>El acceso a los servicios se realiza mediante solicitud y está sujeto a evaluación. Conadvy se reserva el derecho de admitir o no solicitudes conforme a sus criterios de calidad, encaje y capacidad operativa, sin obligación de motivación.</P>
        <P><strong>Advisors:</strong> el solicitante garantiza la veracidad de la información profesional facilitada. Conadvy podrá verificar dicha información y excluir perfiles que incumplan esta garantía.</P>
        <P><strong>Empresas:</strong> el solicitante garantiza que actúa con poder suficiente en representación de la empresa y que la información facilitada es veraz.</P>
      </Section>

      <Section title="4. Condiciones económicas">
        <P>Las condiciones económicas concretas se comunican de forma previa, expresa y por escrito antes de que se devengue importe alguno:</P>
        <P><strong>a) Empresas — cuota de conexión ("success fee"):</strong> el servicio de diagnóstico y presentación no tiene coste de entrada. Conadvy únicamente devenga honorarios cuando se produce una conexión exitosa. El importe se determina en función del tramo de facturación de la empresa, conforme a las condiciones comunicadas antes del inicio del proceso. Si no hay conexión, no hay coste.</P>
        <P><strong>b) Advisors:</strong> la pertenencia a la red puede articularse bajo la modalidad gratuita ("Freemium", con un porcentaje de éxito sobre mandatos) o bajo suscripción mensual (con un porcentaje de éxito reducido), conforme a las condiciones comunicadas en el proceso de admisión.</P>
        <P>Todos los importes se entienden sin IVA u otros impuestos aplicables.</P>
      </Section>

      <Section title="5. Compromiso de no elusión">
        <P>La empresa y el Advisor se comprometen a no eludir la intermediación de Conadvy. Si una empresa formaliza una colaboración con un Advisor presentado por Conadvy (directamente o a través de personas vinculadas) dentro de los meses siguientes a la presentación, se devengará la cuota de conexión correspondiente. Ambas partes se obligan a informar a Conadvy de dichas colaboraciones.</P>
      </Section>

      <Section title="6. Confidencialidad">
        <P>Toda la información intercambiada en el marco del proceso tiene carácter confidencial. La identidad de los Advisors se revela únicamente tras la firma del NDA correspondiente. Cada parte se compromete a utilizar la información recibida exclusivamente para valorar y, en su caso, desarrollar la colaboración propuesta.</P>
      </Section>

      <Section title="7. Obligaciones de las partes">
        <P><strong>De Conadvy:</strong> ejecutar el proceso con diligencia profesional, presentar únicamente perfiles verificados, proteger la confidencialidad y comunicar las condiciones económicas antes de su devengo.</P>
        <P><strong>De la empresa:</strong> facilitar información veraz, mantener la confidencialidad de los perfiles presentados, no contactar directamente a los Advisors al margen del proceso, y abonar la cuota de conexión cuando se devengue.</P>
        <P><strong>Del Advisor:</strong> mantener actualizada su información profesional, comunicar conflictos de interés, respetar la confidencialidad y abonar los importes que le correspondan conforme a su modalidad.</P>
      </Section>

      <Section title="8. Naturaleza de la intermediación y responsabilidad">
        <P>Conadvy aplica un proceso riguroso de diagnóstico, verificación y selección, pero <strong>no garantiza un resultado empresarial determinado</strong>. Los Advisors son profesionales independientes: no existe relación laboral, societaria ni de agencia entre ellos y Conadvy.</P>
        <P>La responsabilidad total de Conadvy quedará limitada, salvo dolo o culpa grave, al importe efectivamente percibido por Conadvy de dicha parte en los 12 meses anteriores al hecho que la origine.</P>
      </Section>

      <Section title="9. Duración y terminación">
        <P>La condición de miembro o cliente se mantiene mientras ninguna de las partes comunique lo contrario. Conadvy podrá suspender o excluir a cualquier usuario en caso de incumplimiento, información falsa, conducta contraria a la confidencialidad o elusión de la intermediación.</P>
      </Section>

      <Section title="10. Modificaciones">
        <P>Conadvy podrá modificar estos Términos publicando la versión actualizada en el sitio web. Las modificaciones no afectarán a los procesos ya iniciados salvo aceptación expresa.</P>
      </Section>

      <Section title="11. Ley aplicable y jurisdicción">
        <P>Estos Términos se rigen por la legislación española. Las partes se someten a los Juzgados y Tribunales de [CIUDAD DEL DOMICILIO SOCIAL], con renuncia expresa a cualquier otro fuero.</P>
      </Section>
    </LegalPage>
  );
}
